import { Availability } from '../types';

export type RoomTab = 'mark' | 'best';

export const ROOM_TAB_STORAGE_PREFIX = 'roomTab:';

export function roomTabStorageKey(roomId: string): string {
  return `${ROOM_TAB_STORAGE_PREFIX}${roomId}`;
}

export function userHasMarkedSlots(
  availability: Availability[],
  participantName: string | null
): boolean {
  if (!participantName) return false;
  return availability.some(a => a.participant === participantName && a.available);
}

export function decideInitialRoomTab(
  availability: Availability[],
  participantName: string | null,
  storedTab: RoomTab | null
): RoomTab {
  if (storedTab === 'mark' || storedTab === 'best') return storedTab;
  return userHasMarkedSlots(availability, participantName) ? 'best' : 'mark';
}

export function readStoredRoomTab(
  roomId: string,
  storage: Pick<Storage, 'getItem'> = localStorage
): RoomTab | null {
  try {
    const v = storage.getItem(roomTabStorageKey(roomId));
    if (v === 'mark' || v === 'best') return v;
    return null;
  } catch {
    return null;
  }
}

export function writeStoredRoomTab(
  roomId: string,
  tab: RoomTab,
  storage: Pick<Storage, 'setItem'> = localStorage
): void {
  try {
    storage.setItem(roomTabStorageKey(roomId), tab);
  } catch {
    /* ignore */
  }
}
